import { ModuleInformation } from "burde";
import * as React from "react";
import { ModuleOption } from "ui/constants";
import * as styles from "./module-picker.css";

type ModulePickerProps = {
    onClick: (module: ModuleOption) => void;
    modules: Array<ModuleOption>;
    selectedModule: ModuleInformation | null;
};

const ModulePicker: React.FC<ModulePickerProps> = ({
    onClick,
    modules,
    selectedModule,
}) => {
    const isSelected = (id: number) => {
        return selectedModule ? selectedModule.id == id : false;
    };

    const getThumbnail = (module: ModuleOption) => {
        return module && module.endpoints && module.endpoints.thumbnail
            ? module.endpoints.thumbnail
            : "";
    };

    return (
        <ul className={styles.iconPicker}>
            {modules.map((module) => (
                <li
                    className={styles.iconPickerLi}
                    key={module.id}
                    onClick={() => onClick(module)}>
                    <div
                        className={`${styles.iconPickerItem} 
                             ${
                                 isSelected(module.id)
                                     ? styles.iconPickerItemSelected
                                     : ""
                             }`}>
                        <div>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: getThumbnail(module),
                                }}
                            />
                            {module.title}
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default ModulePicker;
